import { Container } from "@material-ui/core";
import React, { useContext } from "react";
import AuthContext from "../../hooks/authContext";
import { useTour } from "../ui/TourContext";
import { useNavigate } from "react-router";

const Unauthorized = () => {
  const auth = useContext(AuthContext);
  const { stopTour } = useTour();
  const navigate = useNavigate();

   const handleLogoutAndRedirect = () => {
    try {
      auth.logoutuser?.();
      stopTour?.();
      document.documentElement.classList.remove("dark");
      localStorage.removeItem("clientId");
      localStorage.removeItem("companyId");
      localStorage.removeItem("clients");
      localStorage.removeItem("companies");
      localStorage.setItem("darkMode", "false");
      if (auth?.userProfile?.clientsLength === 0 && auth?.userProfile?.employeesLength === 0) {
        localStorage.removeItem("hasSeenTour");
      } else {
        localStorage.setItem("hasSeenTour", "true");
      }
      navigate("/login");
    } catch (err) {
      console.error("Logout cleanup failed:", err);
    }
  };

  return <Container maxWidth="lg" className="sectionBox">
    {auth?.isLoading !== true && <h3 className={` text-center`}>You May Not Authorized to Access this page.</h3>}
    {auth?.status !== true && <p className={` text-center`}><a href="#login" onClick={handleLogoutAndRedirect}>Login</a></p>}
  </Container>
};

export default Unauthorized;
